namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import ps = Portico.Services;

    export interface IEnterpriseService {
		accountService: ps.IAccountService;
		caseService: ps.ICaseService;
		claimService: ps.IClaimService;
		conversionService: ps.IConversionService;
		debitCardService: ps.IDebitCardService;
		diagnosisService: ps.IDiagnosisService;
		documentService: ps.IDocumentService;
		emailService: ps.IEmailService;
		enrollmentService: ps.IEnrollmentService;
		hubService: ps.IHubService;
		intakeService: ps.IIntakeService;
		locationService: ps.ILocationService;
		locationServiceGateway: ps.ILocationService;
		miscService: ps.IMiscService;
		noteService: ps.INoteService;
		patientAccountService: ps.IPatientAccountService;
		patientService: ps.IPatientService;
		payloadStagingService: ps.IPayloadStagingService;
		payorService: ps.IPayorService;
		pharmacyService: ps.IPharmacyService;
		prescriberService: ps.IPrescriberService;
		prescriptionService: ps.IPrescriptionService;
		programService: ps.IProgramService;
		sessionService: ps.ISessionService;
		siteService: ps.ISiteService;
		siteAccountService: ps.ISiteAccountService;
		surveyService: ps.ISurveyService;
    }

	@Service(
		'app',
		'enterpriseService'
	)
	@Inject(
		'accountService',
		'caseService',
		'claimService',
		'conversionService',
		'debitCardService',
		'diagnosisService',
		'documentService',
		'emailService',
		'enrollmentService',
		'hubService',
		'intakeService',
		'locationServiceClient',  // TODO - This needs to be changed back to just locationService once the Gateway is in production
		'locationService',
		'miscService',
		'noteService',
		'patientAccountService',
		'patientService',
		'payloadStagingService',
		'payorService',
		'pharmacyService',
		'prescriberService',
		'prescriptionService',
		'programService',
		'sessionService',
		'siteService',
		'siteAccountService',
		'surveyService'
	)
	export class EnterpriseService implements IEnterpriseService {
		constructor(
			public accountService: ps.IAccountService,
			public caseService: ps.ICaseService,
			public claimService: ps.IClaimService,
			public conversionService: ps.IConversionService,
			public debitCardService: ps.IDebitCardService,
			public diagnosisService: ps.IDiagnosisService,
			public documentService: ps.IDocumentService,
			public emailService: ps.IEmailService,
			public enrollmentService: ps.IEnrollmentService,
			public hubService: ps.IHubService,
			public intakeService: ps.IIntakeService,
			public locationService: ps.ILocationService,
            public locationServiceGateway: ps.ILocationService, // This was done to continue supporting the older locationService client
			public miscService: ps.IMiscService,
			public noteService: ps.INoteService,
			public patientAccountService: ps.IPatientAccountService,
			public patientService: ps.IPatientService,
			public payloadStagingService: ps.IPayloadStagingService,
			public payorService: ps.IPayorService,
			public pharmacyService: ps.IPharmacyService,
			public prescriberService: ps.IPrescriberService,
			public prescriptionService: ps.IPrescriptionService,
			public programService: ps.IProgramService,
			public sessionService: ps.ISessionService,
			public siteService: ps.ISiteService,
			public siteAccountService: ps.ISiteAccountService,
			public surveyService: ps.ISurveyService
        ) { }
	}
}